import { formatCurrency } from '@/utils/money';
import { NewOrder_OrderFieldsFragment } from '@/types';
import { useMemo } from 'react';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

export const useGetOfflineTotalPrice = (
  ordersItems: NewOrder_OrderFieldsFragment['orders_items'],
): string | null => {
  const { currencyCode, getVariantPackInfo } = useVariantPackInfoContext();

  return useMemo(() => {
    if (ordersItems.length === 0) {
      return null;
    }
    const total = ordersItems.reduce((acc, item) => {
      const variantPackInfo = getVariantPackInfo(item.variants_pack.uuid);
      const price = variantPackInfo?.priceInMicros || 0;
      const quantity = item.order_item_prices?.pack_quantity_at_order || 0;
      const unitCount = variantPackInfo?.unitCount || 1;
      return acc + price * quantity * unitCount;
    }, 0);
    return formatCurrency(total, currencyCode);
  }, [ordersItems, getVariantPackInfo, currencyCode]);
};
